import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-description',
  templateUrl: './section-description.component.html',
  styleUrls: ['./section-description.component.css']
})
export class SectionDescriptionComponent {
  @Input() descrption: string = '';

  onConfirm() {}
}
